import src from "IMAGE";
export default { src, width: 447, height: 84, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/ACoobGZAP4uFRUOYkk9NpKBYVrGsX129uGNgxsM0M4OIADMxnKpaV7HHVFKlvFRSl7BLSoqkQkB9mDw6cYsdHERbmxobq5h6VyEAAAAASUVORK5CYII="};
